/* Keeps the buy-more-save-more codes on the cart.
   The builder stores the code list in a cookie when it applies them. Shopify
   drops any code the cart does not yet qualify for when the shopper opens
   checkout, so after that a shopper who comes back and adds shirts would stop
   stepping up. This script re-adds missing codes after every cart change and
   on page load, then refreshes the theme's cart drawer. Does nothing without
   the cookie. */
(function () {
  'use strict';
  var COOKIE = 'neat_ladder';
  function codes() {
    var m = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
    if (!m) return [];
    return decodeURIComponent(m[1]).split(',').map(function (c) { return c.trim().toUpperCase(); }).filter(Boolean);
  }
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  // Ladder shoppers never see the old Fast Bundle "Buy More, Save More" bar in
  // the drawer or cart page. The bar is rendered server side, so hide it here.
  var marked = false;
  function mark() {
    if (marked || !codes().length) return;
    marked = true;
    document.documentElement.classList.add('neat-ladder');
    var st = document.createElement('style');
    st.textContent = 'html.neat-ladder .bundle-progress-wrapper{display:none !important}';
    (document.head || document.documentElement).appendChild(st);
  }
  mark();
  var busy = false, again = false;
  function ensure() {
    var want = codes();
    if (!want.length) return Promise.resolve();
    mark();
    if (busy) { again = true; return Promise.resolve(); }
    busy = true;
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var have = (cart.discount_codes || []).map(function (d) { return String(d.code).toUpperCase(); });
        var missing = want.filter(function (c) { return have.indexOf(c) === -1; });
        if (!missing.length || !cart.item_count) return null;
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: have.concat(missing).join(',') })
        }).then(function () {
          var drawer = document.querySelector('m-cart-drawer');
          if (drawer && typeof drawer.onCartDrawerUpdate === 'function') drawer.onCartDrawerUpdate();
          if (document.body.classList.contains('template-cart')) window.location.reload();
        });
      })
      .catch(function () {})
      .then(function () { busy = false; if (again) { again = false; ensure(); } });
  }
  // Watch the theme's own cart calls (add, change, update by quantity) and re-check after each.
  var realFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = realFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      var body = init && typeof init.body === 'string' ? init.body : '';
      if (body.indexOf('"discount"') === -1) p.then(function () { setTimeout(ensure, 150); }, function () {});
    }
    return p;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { ensure(); });
  else ensure();
  window.addEventListener('pageshow', function (e) { if (e.persisted) ensure(); });
})();
